module.exports = __webpack_public_path__ + "static/028-08b156c77fe7151bae72b17ba934acd7.jpg";